<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-divider>我加入的俱乐部</el-divider>
      <div v-if="row.club.length > 0">
        <el-table ref="clubTable" :data="row.club" row-key="id" :show-header="false">
          <el-table-column label="单位名称" fixed="left" prop="title">
            <template scope="scope">
              {{scope.row.danwei}}
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="zhuantai">
            <template scope="scope">
              <el-tag v-if="scope.row.registstatus == 1">
                等待审核
              </el-tag>
              <el-tag
                  v-else-if="scope.row.registstatus == 2"
                  type="success"
              >
                审核成功
              </el-tag>
              <el-tag
                  v-else-if="scope.row.registstatus == 3"
              >
                审核失败
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="日期" prop="riqi">
            <template scope="scope">
              {{ scope.row.create_time_str }}
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="caozuo">
            <template scope="scope">
              <el-button class="look-order" size="medium" @click="toClubNext(scope.row.id)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>


      <el-divider>我的考级中心（点）</el-divider>
      <div v-if="row.exame_center.length > 0">

        <el-table ref="exammeTable" :data="row.exame_center" row-key="id" :show-header="false">
          <el-table-column label="单位名称" fixed="left" prop="title">
            <template scope="scope">
              {{scope.row.danwei}}
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="zhuantai">
            <template scope="scope">
              <el-tag v-if="scope.row.kaojiregist_status == 1">
                等待审核
              </el-tag>
              <el-tag
                  v-else-if="scope.row.kaojiregist_status == 2"
                  type="success"
              >
                审核成功
              </el-tag>
              <el-tag
                  v-else-if="scope.row.kaojiregist_status == 3"
              >
                审核失败
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="日期" prop="riqi">
            <template scope="scope">
              {{ scope.row.create_time_str }}
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="caozuo">
            <template scope="scope">
              <el-button class="look-order" size="medium" v-rblink="{name: 'QcxjDetail', query: {id: scope.row.id}}">查看详情</el-button>
              <el-button class="look-order" size="medium" @click="toKaojiNext(scope.row.id)">确认验收信息</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-divider>已有俱乐部/考级中心/考级点</el-divider>
      <div class="tc">
        <el-row>
          <el-button round @click="toClub">创建俱乐部</el-button>
          <el-button round @click="toKaoji">创建考级中心/考级点</el-button>
          <el-button round @click="toAuth">点击认证已有俱乐部/考级中心/考级点</el-button>
        </el-row>
      </div>
    </div>

    <el-dialog :visible.sync="clubShow" title="创建须知">
      <div class="dialog-content">
        <div class="dialog-step-li">1.申请成为会员单位后，即成为一星俱乐部；</div>

        <div class="dialog-step-li">2.俱乐部升级类别</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）二星俱乐部</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）三星俱乐部</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（3）四星俱乐部</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（4）五星俱乐部</div>
          </li>
        </ul>

        <!--        <div class="dialog-step-li">3.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/</div>-->
        <div class="dialog-step-li">
          <div>3.附件下载</div>
          <el-link
                   @click="download('啦啦操星级俱乐部管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf')">
            啦啦操星级俱乐部管理办法
          </el-link>
        </div>

        <span slot="footer" class="dialog-footer">
    <el-button @click="clubShow = false">我再想想</el-button>
    <el-button type="primary" @click="toClubNext(0)">我已阅读并同意遵守本须知声明的所有条款 点击进行创建</el-button>
  </span>
        <!--        <van-button type="primary" size="large" @click="toClubNext(0)">-->
        <!--          <div>我已阅读并同意遵守本须知声明的所有条款</div>-->
        <!--          <div>点击进行创建</div>-->
        <!--        </van-button>-->
        <!--        <van-button type="default" size="large" @click="clubShow = false">我再想想</van-button>-->
      </div>
    </el-dialog>
    <el-dialog :visible.sync="kaojiShow" title="创建须知">
      <div class="dialog-content">
        <div class="dialog-step-li">1.可创建类型为：</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）七彩星级指定考级点</div>
            <div class="li-right">0元</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）七彩星级指定样板考级点</div>
            <div class="li-right">9800元</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（3）七彩星级指定考级中心</div>
            <div class="li-right">120000元</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（4）七彩星级指定样板考级中心</div>
            <div class="li-right">135000元</div>
          </li>
        </ul>

        <div class="dialog-step-li">2.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/</div>

        <div>3.附件下载</div>
        <div class="dialog-step-li">
          <el-link
                   @click="download('啦啦操七彩星级管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-14.pdf')">
            啦啦操七彩星级管理办法
          </el-link>
        </div>
        <div class="dialog-step-li">
          <el-link
              @click="download('七彩星级考级中心（点）加盟方案', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-12.pdf')">
            七彩星级考级中心（点）加盟方案
          </el-link>
        </div>
        <div class="dialog-step-li">
          <el-link
              @click="download('考级点文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-10.zip')">
            考级点文化包（兼容版）请下载制作
          </el-link>
        </div>
        <div class="dialog-step-li">
          <el-link
              @click="download('考级中心文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-12.zip')">
            考级中心文化包（兼容版）请下载制作
          </el-link>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="kaojiShow = false">我再想想</el-button>
          <el-button type="primary" @click="toKaojiNext(0)">我已阅读并同意遵守本须知声明的所有条款 点击进行创建</el-button>
        </span>

      </div>
    </el-dialog>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.dialog-head {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  padding: 20px 0 20px;
}

.dialog-content {
  padding: 0 15px;
  font-size: 14px;
}

.dialog-content >>> .van-button {
  line-height: 1.2;
  font-size: 14px;
}

.dialog-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-step-li {
  margin: 10px 0 15px;
}

.dialog-step-li-text {
  color: #409eff;
  margin-top: 3px;
}

.bottom-button {
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 10px;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubIndex',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loading: false,
      clubShow: false,
      kaojiShow: false,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {
        danwei: {},
        exame_center: {},
        club: {}
      },
      formData: {},
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "我的俱乐部"
    this.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/myclub', {}, (res) => {
        that.row = res.data;
        that.loading = true
      }, (res) => {

        that.loading = true
        console.log('errrrrr')
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    toClub() {
      this.clubShow = true
    },

    toKaoji() {
      this.kaojiShow = true
    },

    // 官网已有考级中心认证
    toAuth() {
      rbLink({
        name: 'QcxjStationBind',
      });
    },

    // 创建俱乐部
    toClubNext(id) {
      rbLink({
        name: 'ClubApplyMine',
        query: {
          id: id
        }
      });
    },

    // 创建考级中心/点
    toKaojiNext(id) {
      rbLink({
        name: 'QcxjStationApplyMine',
        query: {
          id: id
        }
      });
    },

    // 下载附件
    download(name, url) {
      appEvent({
        name: 'downloadFile',
        query: {
          name: name,
          url: url
        }
      });
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// ClubIndex.vue?3bad4a3a